import { DocumentLinkType, PolicyDocument, ProtoDb } from '../models/domain.models';
import { DocumentAssociation } from '../models/views.models';

const TYPE_ORDER: DocumentLinkType[] = ['policy', 'endorsement', 'claim', 'ticket', 'person'];

export function entityLabel(db: ProtoDb, type: DocumentLinkType, oid: string): string | null {
  switch (type) {
    case 'policy': {
      const policy = db.policies.find(p => p.oid === oid);
      return policy ? `Póliza ${policy.number}` : null;
    }
    case 'claim': {
      const claim = db.claims.find(c => c.oid === oid);
      return claim ? `Siniestro ${claim.number}` : null;
    }
    case 'endorsement': {
      const endorsement = db.endorsements.find(e => e.oid === oid);
      return endorsement ? `Endoso ${endorsement.number}` : null;
    }
    case 'ticket': {
      const ticket = db.tickets.find(t => t.oid === oid);
      return ticket ? `Ticket ${ticket.number}` : null;
    }
    case 'person':
      return db.persons.find(p => p.oid === oid)?.displayName ?? null;
  }
}

/** Everything a document is attached to: what P-41 / P-62 already know, plus the associations added in P-70. */
export function documentAssociations(doc: PolicyDocument, db: ProtoDb): DocumentAssociation[] {
  const out: DocumentAssociation[] = [];
  const add = (type: DocumentLinkType, oid: string | null | undefined) => {
    if (!oid || out.some(a => a.type === type && a.oid === oid)) return;
    const label = entityLabel(db, type, oid);
    if (label) out.push({ type, oid, label });
  };
  add('policy', doc.policyOid);
  add('claim', doc.claimOid);
  add('endorsement', db.endorsements.find(e => e.documentOid === doc.oid)?.oid);
  doc.links.forEach(link => add(link.type, link.oid));
  add('person', doc.personOid);
  return out.sort((a, b) => TYPE_ORDER.indexOf(a.type) - TYPE_ORDER.indexOf(b.type));
}

export function isAssociated(doc: PolicyDocument, db: ProtoDb, type: DocumentLinkType, oid: string): boolean {
  return documentAssociations(doc, db).some(a => a.type === type && a.oid === oid);
}
